import React from "react";
import { Leaf, Heart, Users } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useReveal, useParallax } from "@/hooks/useReveal";
import { PageHero, Eyebrow, SectionTitle } from "@/components/shared";
import { Ornament } from "@/components/Ornament";
import { IMAGES } from "@/data/treasures";

const valueIcons = [Leaf, Heart, Users];

const GeschichtePage = () => {
  const { t, lang } = useLang();
  const ref = useReveal([lang]);
  const parallaxRef = useParallax(60);

  return (
    <div ref={ref}>
      <PageHero image={IMAGES.storyImage} eyebrow={t.story.eyebrow} title={t.story.title} lead={t.story.lead} />

      <section className="py-24 md:py-32 bg-cream grain-overlay">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 items-center">
          <div data-reveal>
            <Eyebrow>{t.story.eyebrow}</Eyebrow>
            <SectionTitle>{t.story.title}</SectionTitle>
            <p className="mt-6 text-espresso/70 text-lg leading-relaxed font-sans">{t.story.body1}</p>
            <p className="mt-4 text-espresso/70 text-lg leading-relaxed font-sans">{t.story.body2}</p>
            <Ornament className="mt-8 justify-start opacity-70" width={200} />
          </div>
          <div className="relative" data-reveal data-reveal-delay="0.15">
            <div className="overflow-hidden rounded-2xl">
              <img ref={parallaxRef} src={IMAGES.brockenWide} alt="Geschichte" className="w-full h-[540px] object-cover scale-110" loading="lazy" />
            </div>
            <div className="absolute -top-6 -left-6 w-32 h-32 rounded-2xl border border-gold/40 hidden md:block" />
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-28 bg-sand">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-3 gap-8">
            {t.story.values.map((v, i) => {
              const Icon = valueIcons[i];
              return (
                <div key={i} data-reveal data-reveal-delay={0.1 * i} data-testid={`value-${i}`} className="text-center px-6">
                  <div className="w-16 h-16 rounded-full bg-espresso mx-auto flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-gold" />
                  </div>
                  <h3 className="font-serif text-2xl text-espresso mb-2">{v.t}</h3>
                  <p className="text-espresso/65 font-sans">{v.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GeschichtePage;
